import { Component } from '@angular/core';

@Component({
  selector: 'app-delayed-indicator', standalone: false,
  template: `<span class="app-delayed-indicator" role="status" [attr.aria-label]="'common.loadingData' | translate"></span>`,
  host: { class: 'app-delayed-indicator-host' },
})
export class DelayedIndicatorComponent {}
